<div class="cvds-room">
  <div *ngIf="fieldsModel.length">
    <cv-cvds-field-table
      [items]="fieldsModel"
    ></cv-cvds-field-table>
  </div>

  <div *ngFor="let item of fieldsSections">
    <cv-cvds-field-array
      [items]="item.items"
      [fields]="item.fields"
      [title]="item.title"
    ></cv-cvds-field-array>
  </div>

  <div *ngIf="room.cv_photos?.length">
    <div class="card cv-card__main shadow-sm">
      <div class="card-header">Room Photos</div>
      <div class="card-body">
        <cv-cvds-photos 
          [photos]="room.cv_photos">
        </cv-cvds-photos>
      </div>
    </div>
  </div>
</div>